export default __webpack_public_path__ + "static/media/office_6.49be051b.jpeg";